/** Which empty state a list should render when it has no row to show. */
export type ListEmptyKind =
  | "filtered"
  | "empty-with-action"
  | "empty-read-only";

/**
 * Picks the empty state of a list: active filters that matched nothing
 * ("filtered", offers a clear-filters action) are distinct from a resource
 * that is truly empty, which offers a next action only when the role can
 * create ("empty-with-action") and otherwise just explains the list
 * ("empty-read-only").
 */
export const selectListEmptyKind = ({
  hasActiveFilters,
  canCreate,
}: {
  hasActiveFilters: boolean;
  canCreate: boolean;
}): ListEmptyKind => {
  if (hasActiveFilters) return "filtered";
  return canCreate ? "empty-with-action" : "empty-read-only";
};

/**
 * True when `filterValues` holds at least one filter that is not just a
 * default the list applies on its own (e.g. Opciones starts on "disponible"),
 * so a default-only view still counts as the truly-empty resource.
 */
export const hasUserFilters = (
  filterValues: Record<string, unknown> | undefined,
  defaultFilterValues: Record<string, unknown> = {},
): boolean =>
  Object.entries(filterValues ?? {}).some(
    ([key, value]) =>
      !(key in defaultFilterValues) || defaultFilterValues[key] !== value,
  );
